/**
 * Namaste Restaurant — QR Table Ordering + Firebase KDS + WhatsApp notify
 * Orders sync in realtime via Firebase Realtime Database (free Spark plan).
 * WhatsApp is notification-only; Kitchen Display does not depend on it.
 */
(function () {
  'use strict';

  var TABLE_KEY = 'nr_table';
  var KDS_AUTH = 'nr_kds_auth';
  var LOCAL_ORDERS = 'nr_kitchen_orders'; // offline fallback
  var db = null;
  var firebaseReady = false;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function getTable() {
    try {
      return sessionStorage.getItem(TABLE_KEY) || localStorage.getItem(TABLE_KEY) || '';
    } catch (e) { return ''; }
  }
  function setTable(n) {
    try {
      sessionStorage.setItem(TABLE_KEY, String(n));
      localStorage.setItem(TABLE_KEY, String(n));
    } catch (e) {}
  }

  function detectTableFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      var t = params.get('table');
      if (t && /^\d+$/.test(t)) {
        var max = parseInt(document.body.dataset.tableCount || '5', 10) || 5;
        var num = parseInt(t, 10);
        if (num >= 1 && num <= max) {
          setTable(num);
          if (window.history && window.history.replaceState) {
            params.delete('table');
            var q = params.toString();
            window.history.replaceState({}, '', window.location.pathname + (q ? '?' + q : '') + window.location.hash);
          }
          return num;
        }
      }
    } catch (e) {}
    return null;
  }

  function updateTableUI() {
    var t = getTable();
    var banner = $('#NrTableBanner');
    var badge = $('#NrTableBadge');
    var floatEl = $('#NrTableFloat');
    var floatLabel = $('#NrTableFloatLabel');
    if (t) {
      if (banner) banner.style.display = 'block';
      if (badge) badge.textContent = 'Table ' + t;
      if (floatEl) {
        floatEl.style.display = 'flex';
        if (floatLabel) floatLabel.textContent = 'Table ' + t;
      }
      document.body.classList.add('nr-has-table');
      document.body.dataset.table = t;
    } else {
      if (banner) banner.style.display = 'none';
      if (floatEl) floatEl.style.display = 'none';
      document.body.classList.remove('nr-has-table');
    }
  }

  function formatMoney(cents) {
    return '₹' + ((cents || 0) / 100).toFixed(0);
  }

  function orderId(table) {
    var d = new Date();
    var p = function (x) { return (x < 10 ? '0' : '') + x; };
    return 'NR-T' + table + '-' + d.getFullYear().toString().slice(-2) +
      p(d.getMonth() + 1) + p(d.getDate()) + '-' +
      p(d.getHours()) + p(d.getMinutes()) + p(d.getSeconds());
  }

  function escapeHtml(s) {
    return String(s || '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ---------- Firebase ---------- */
  function firebaseConfigFromBody() {
    var b = document.body;
    var apiKey = b.dataset.fbApiKey || '';
    var databaseURL = b.dataset.fbDbUrl || '';
    if (!apiKey || !databaseURL) return null;
    return {
      apiKey: apiKey,
      authDomain: b.dataset.fbAuthDomain || '',
      databaseURL: databaseURL,
      projectId: b.dataset.fbProjectId || '',
      appId: b.dataset.fbAppId || '',
      messagingSenderId: b.dataset.fbSenderId || ''
    };
  }

  function initFirebase() {
    return new Promise(function (resolve) {
      if (document.body.dataset.fbEnabled === 'false') {
        resolve(false);
        return;
      }
      var cfg = firebaseConfigFromBody();
      if (!cfg) {
        console.warn('[NR] Firebase not configured — using local fallback only');
        resolve(false);
        return;
      }
      if (window.firebase && firebase.apps && firebase.apps.length) {
        db = firebase.database();
        firebaseReady = true;
        resolve(true);
        return;
      }
      // Load Firebase 8 compat from CDN (works without bundler)
      var s1 = document.createElement('script');
      s1.src = 'https://www.gstatic.com/firebasejs/9.23.0/firebase-app-compat.js';
      s1.onload = function () {
        var s2 = document.createElement('script');
        s2.src = 'https://www.gstatic.com/firebasejs/9.23.0/firebase-database-compat.js';
        s2.onload = function () {
          try {
            firebase.initializeApp(cfg);
            db = firebase.database();
            firebaseReady = true;
            resolve(true);
          } catch (e) {
            console.error('[NR] Firebase init failed', e);
            resolve(false);
          }
        };
        s2.onerror = function () { resolve(false); };
        document.head.appendChild(s2);
      };
      s1.onerror = function () { resolve(false); };
      document.head.appendChild(s1);
    });
  }

  function localLoad() {
    try { return JSON.parse(localStorage.getItem(LOCAL_ORDERS) || '[]'); }
    catch (e) { return []; }
  }
  function localSave(list) {
    try {
      localStorage.setItem(LOCAL_ORDERS, JSON.stringify(list.slice(0, 100)));
      localStorage.setItem('nr_kitchen_ping', String(Date.now()));
    } catch (e) {}
  }

  function pushOrder(order) {
    // Always keep local copy
    var list = localLoad();
    var idx = list.findIndex(function (o) { return o.id === order.id; });
    if (idx >= 0) list[idx] = order; else list.unshift(order);
    localSave(list);

    if (firebaseReady && db) {
      return db.ref('orders/' + order.id).set(order)
        .then(function () { return order; })
        .catch(function (err) {
          console.error('[NR] Firebase write failed', err);
          return order;
        });
    }
    return Promise.resolve(order);
  }

  function updateOrderStatus(id, status) {
    var list = localLoad();
    list.forEach(function (o) {
      if (o.id === id) {
        o.status = status;
        o.updated_at = new Date().toISOString();
      }
    });
    localSave(list);

    if (firebaseReady && db) {
      return db.ref('orders/' + id).update({
        status: status,
        updated_at: new Date().toISOString()
      }).catch(function (e) { console.error(e); });
    }
    return Promise.resolve();
  }

  function removeOrder(id) {
    var list = localLoad().filter(function (o) { return o.id !== id; });
    localSave(list);
    if (firebaseReady && db) {
      return db.ref('orders/' + id).remove().catch(function () {});
    }
    return Promise.resolve();
  }

  function subscribeOrders(callback) {
    if (firebaseReady && db) {
      var ref = db.ref('orders');
      ref.orderByChild('created_at').limitToLast(80).on('value', function (snap) {
        var val = snap.val() || {};
        var list = Object.keys(val).map(function (k) { return val[k]; });
        list.sort(function (a, b) {
          return (b.created_at || '').localeCompare(a.created_at || '');
        });
        localSave(list);
        callback(list);
      }, function (err) {
        console.error('[NR] Firebase listen error', err);
        callback(localLoad());
      });
      return function () { ref.off(); };
    }
    // Fallback: poll localStorage
    callback(localLoad());
    var t = setInterval(function () { callback(localLoad()); }, 3000);
    return function () { clearInterval(t); };
  }

  /* ---------- Order build / WhatsApp ---------- */
  function buildOrderFromCart(cart, table, notes) {
    var now = new Date();
    return {
      id: orderId(table),
      table: String(table),
      status: 'new',
      notes: notes || '',
      items: (cart.items || []).map(function (it) {
        return {
          name: it.product_title,
          quantity: it.quantity,
          price: it.final_line_price,
          unit_price: it.final_price
        };
      }),
      total: cart.total_price,
      created_at: now.toISOString(),
      created_label: now.toLocaleString(),
      updated_at: now.toISOString(),
      shop: document.body.dataset.shopName || 'Namaste Restaurant'
    };
  }

  function whatsappText(order) {
    var lines = [
      '*NEW TABLE ORDER — Namaste*',
      '',
      '*Table:* ' + order.table,
      '*Order:* ' + order.id,
      '*Time:* ' + order.created_label,
      '',
      '*Items:*'
    ];
    order.items.forEach(function (it, i) {
      lines.push((i + 1) + '. ' + it.name + ' × ' + it.quantity + ' — ' + formatMoney(it.price));
    });
    if (order.notes) {
      lines.push('');
      lines.push('*Notes:* ' + order.notes);
    }
    lines.push('');
    lines.push('*Total: ' + formatMoney(order.total) + '*');
    lines.push('');
    lines.push('_Kitchen Display updates automatically_');
    return lines.join('\n');
  }

  function openWhatsApp(order) {
    if (document.body.dataset.waNotify === 'false') return;
    var wa = (document.body.dataset.whatsapp || '').replace(/\D/g, '');
    if (!wa) return;
    window.open('https://wa.me/' + wa + '?text=' + encodeURIComponent(whatsappText(order)), '_blank');
  }

  function clearCart() {
    return fetch('/cart/clear.js', {
      method: 'POST',
      headers: { Accept: 'application/json' }
    }).then(function (r) { return r.json(); }).catch(function () { return {}; });
  }

  function showConfirm(order) {
    var el = $('#NrTableOrderConfirm');
    var meta = $('#NrOrderConfirmMeta');
    if (!el) return;
    if (meta) {
      meta.innerHTML =
        '<div><strong>Order</strong> ' + escapeHtml(order.id) + '</div>' +
        '<div><strong>Table</strong> ' + escapeHtml(order.table) + '</div>' +
        '<div><strong>Total</strong> ' + formatMoney(order.total) + '</div>';
    }
    el.style.display = 'flex';
  }

  function placeTableOrder() {
    var table = getTable();
    if (!table) {
      if (window.NR && NR.toast) NR.toast('Scan your table QR code first');
      else alert('Please scan the QR code on your table to start ordering.');
      return;
    }
    var notesEl = $('#NrOrderNotes');
    var notes = notesEl ? notesEl.value.trim() : '';
    var btn = $('#NrPlaceTableOrder');
    if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) {
          if (window.NR && NR.toast) NR.toast('Cart is empty');
          throw new Error('empty');
        }
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            attributes: {
              table_number: String(table),
              order_type: 'table_order',
              order_notes: notes
            },
            note: 'Table ' + table + (notes ? ' | ' + notes : '')
          })
        }).then(function () { return cart; });
      })
      .then(function (cart) {
        var order = buildOrderFromCart(cart, table, notes);
        return pushOrder(order).then(function () {
          openWhatsApp(order);
          showConfirm(order);
          if (document.body.dataset.clearCart !== 'false') {
            return clearCart().then(function () {
              fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
                $$('.nr-cart-badge').forEach(function (el) {
                  el.textContent = c.item_count;
                  el.style.display = c.item_count > 0 ? 'grid' : 'none';
                });
                var bar = $('#NrMobBar');
                if (bar) bar.classList.toggle('active', c.item_count > 0);
              });
            });
          }
        });
      })
      .catch(function (err) {
        if (err && err.message === 'empty') return;
        if (window.NR && NR.toast) NR.toast('Could not place order. Try again.');
      })
      .finally(function () {
        if (btn) {
          btn.disabled = false;
          btn.textContent = document.body.dataset.orderBtnLabel || 'Place Table Order';
        }
      });
  }

  /* ---------- KDS UI ---------- */
  function statusNext(s) {
    if (s === 'new') return 'preparing';
    if (s === 'preparing') return 'ready';
    if (s === 'ready') return 'served';
    return 'served';
  }

  function renderKds(orders) {
    var board = $('#NrKdsBoard');
    if (!board || board.style.display === 'none') return;
    orders = orders || localLoad();

    // Filters
    var filterTable = ($('#NrKdsFilterTable') && $('#NrKdsFilterTable').value) || 'all';
    var filterStatus = ($('#NrKdsFilterStatus') && $('#NrKdsFilterStatus').value) || 'all';
    var q = (($('#NrKdsSearch') && $('#NrKdsSearch').value) || '').trim().toLowerCase();

    var filtered = orders.filter(function (o) {
      if (filterTable !== 'all' && String(o.table) !== String(filterTable)) return false;
      if (filterStatus !== 'all' && (o.status || 'new') !== filterStatus) return false;
      if (q) {
        var hay = (o.id + ' ' + o.table + ' ' + (o.notes || '') + ' ' +
          (o.items || []).map(function (i) { return i.name; }).join(' ')).toLowerCase();
        if (hay.indexOf(q) === -1) return false;
      }
      return true;
    });

    var buckets = { new: [], preparing: [], ready: [], served: [] };
    filtered.forEach(function (o) {
      var st = o.status || 'new';
      if (!buckets[st]) buckets[st] = [];
      buckets[st].push(o);
    });

    ['new', 'preparing', 'ready', 'served'].forEach(function (st) {
      var listId = { new: 'NrKdsNew', preparing: 'NrKdsPreparing', ready: 'NrKdsReady', served: 'NrKdsServed' }[st];
      var list = $('#' + listId);
      if (!list) return;
      var items = buckets[st] || [];
      var countEl = $('[data-count="' + st + '"]');
      if (countEl) countEl.textContent = items.length;
      if (!items.length) {
        list.innerHTML = '<div class="nr-kds-empty">No orders</div>';
        return;
      }
      list.innerHTML = items.map(function (o) {
        var age = '';
        try {
          var mins = Math.floor((Date.now() - new Date(o.created_at).getTime()) / 60000);
          age = mins <= 0 ? 'Just now' : mins + 'm ago';
        } catch (e) { age = o.created_label || ''; }
        var itemsHtml = (o.items || []).map(function (it) {
          return '<li><span>' + escapeHtml(it.name) + '</span><span>×' + it.quantity + '</span></li>';
        }).join('');
        var nextLabel = { new: 'Start preparing', preparing: 'Mark ready', ready: 'Mark served', served: 'Clear' }[st];
        return (
          '<article class="nr-kds-card' + (st === 'new' ? ' nr-kds-card-new' : '') + '" data-id="' + escapeHtml(o.id) + '">' +
          '<div class="nr-kds-card-top">' +
          '<span class="nr-kds-table">T' + escapeHtml(o.table) + '</span>' +
          '<span class="nr-kds-age">' + escapeHtml(age) + '</span>' +
          '</div>' +
          '<div class="nr-kds-id">' + escapeHtml(o.id) + '</div>' +
          '<ul class="nr-kds-items">' + itemsHtml + '</ul>' +
          (o.notes ? '<div class="nr-kds-notes">' + escapeHtml(o.notes) + '</div>' : '') +
          '<div class="nr-kds-card-foot">' +
          '<strong>' + formatMoney(o.total) + '</strong>' +
          (st !== 'served'
            ? '<button type="button" class="nr-btn nr-btn-primary nr-btn-sm" data-advance="' + escapeHtml(o.id) + '">' + nextLabel + '</button>'
            : '<button type="button" class="nr-btn nr-btn-ghost nr-btn-sm" data-remove="' + escapeHtml(o.id) + '">Clear</button>') +
          '</div></article>'
        );
      }).join('');
    });

    $$('[data-advance]').forEach(function (btn) {
      btn.onclick = function () {
        var id = btn.dataset.advance;
        var list = localLoad();
        var o = list.find(function (x) { return x.id === id; });
        var next = statusNext(o ? o.status : 'new');
        updateOrderStatus(id, next).then(function () {
          // Firebase listener will re-render; also local
          renderKds(localLoad());
        });
      };
    });
    $$('[data-remove]').forEach(function (btn) {
      btn.onclick = function () {
        removeOrder(btn.dataset.remove).then(function () {
          renderKds(localLoad());
        });
      };
    });
  }

  function initKds() {
    var root = $('#NrKds');
    if (!root) return;
    var pin = root.dataset.pin || '1234';
    var lock = $('#NrKdsLock');
    var board = $('#NrKdsBoard');
    var unsub = null;

    function unlock() {
      try { sessionStorage.setItem(KDS_AUTH, '1'); } catch (e) {}
      if (lock) lock.style.display = 'none';
      if (board) board.style.display = 'block';
      if (unsub) unsub();
      unsub = subscribeOrders(function (list) { renderKds(list); });
    }
    function lockBoard() {
      try { sessionStorage.removeItem(KDS_AUTH); } catch (e) {}
      if (unsub) { unsub(); unsub = null; }
      if (lock) lock.style.display = 'flex';
      if (board) board.style.display = 'none';
    }

    try { if (sessionStorage.getItem(KDS_AUTH) === '1') unlock(); } catch (e) {}

    var unlockBtn = $('#NrKdsUnlock');
    var pinInput = $('#NrKdsPin');
    if (unlockBtn) {
      unlockBtn.addEventListener('click', function () {
        if (String(pinInput && pinInput.value) === String(pin)) {
          var err = $('#NrKdsPinError');
          if (err) err.style.display = 'none';
          unlock();
        } else {
          var err2 = $('#NrKdsPinError');
          if (err2) err2.style.display = 'block';
        }
      });
    }
    if (pinInput) {
      pinInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && unlockBtn) unlockBtn.click();
      });
    }
    var lockBtn = $('#NrKdsLockBtn');
    if (lockBtn) lockBtn.addEventListener('click', lockBoard);
    var refreshBtn = $('#NrKdsRefresh');
    if (refreshBtn) refreshBtn.addEventListener('click', function () { renderKds(localLoad()); });

    ['NrKdsFilterTable', 'NrKdsFilterStatus', 'NrKdsSearch'].forEach(function (id) {
      var el = $('#' + id);
      if (el) el.addEventListener(el.tagName === 'INPUT' ? 'input' : 'change', function () {
        renderKds(localLoad());
      });
    });

    setInterval(function () {
      var clock = $('#NrKdsClock');
      if (clock) clock.textContent = new Date().toLocaleTimeString();
    }, 1000);
  }

  /* ---------- Admin page (same KDS with filters always visible) ---------- */
  function init() {
    detectTableFromUrl();
    updateTableUI();

    var placeBtn = $('#NrPlaceTableOrder');
    if (placeBtn) placeBtn.addEventListener('click', placeTableOrder);

    var closeConfirm = $('#NrOrderConfirmClose');
    if (closeConfirm) {
      closeConfirm.addEventListener('click', function () {
        var el = $('#NrTableOrderConfirm');
        if (el) el.style.display = 'none';
        if (window.NR && NR.closeCart) NR.closeCart();
        var menu = document.getElementById('menu');
        if (menu) menu.scrollIntoView({ behavior: 'smooth' });
      });
    }

    window.NR = window.NR || {};
    window.NR.getTable = getTable;
    window.NR.setTable = setTable;
    window.NR.whatsappOrder = function () {
      var table = getTable();
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!cart.items || !cart.items.length) {
            if (NR.toast) NR.toast('Cart is empty');
            return;
          }
          var notesEl = $('#NrOrderNotes');
          var notes = notesEl ? notesEl.value.trim() : '';
          if (table) {
            var order = buildOrderFromCart(cart, table, notes);
            openWhatsApp(order);
          } else {
            var wa = (document.body.dataset.whatsapp || '').replace(/\D/g, '');
            var lines = cart.items.map(function (it, i) {
              return (i + 1) + '. ' + it.product_title + ' × ' + it.quantity + ' — ' + formatMoney(it.final_line_price);
            });
            var msg = (document.body.dataset.waPrefix || '*New Order*') + '\n\n' + lines.join('\n') +
              '\n\n*Total: ' + formatMoney(cart.total_price) + '*';
            if (notes) msg += '\n*Notes:* ' + notes;
            window.open('https://wa.me/' + wa + '?text=' + encodeURIComponent(msg), '_blank');
          }
        });
    };

    initFirebase().then(function () {
      initKds();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
